import React, { Component } from "react";
import styles from "./NeighbourhoodName.scss";
import {connect} from 'react-redux';

class NeighbourhoodName extends Component {
  constructor(props) {
      super(props);
      this.state = { };
  }

  render() {
    return (
      <div className={styles.InfoBox}>
        {this.props.neighbourhood_hover_name &&
        !this.props.selected_neighbourhood_name &&
          <div className={styles.InfoIcon}>
            <h3>{this.props.neighbourhood_hover_name}</h3>
          </div>
        }
      </div>
    )
  }

}

function mapStateToProps(state) {
  return {
    selected_neighbourhood_name: state.nav.selected_neighbourhood_name,
    neighbourhood_hover_name: state.nav.neighbourhood_hover_name,
  };
}

const actions = { }

export default connect(mapStateToProps, actions)(NeighbourhoodName);



// WEBPACK FOOTER //
// ./src/components/pages/Map/NeighbourhoodName/NeighbourhoodName.js